export const checkIfUserHasAtLeastOneAllowedPermission = (
    listOfAllowedPermissions: string[] | undefined,
    userPermissions: string[],
) => {
    if (!listOfAllowedPermissions || listOfAllowedPermissions.length === 0) {
        return true;
    }

    for (let i = 0; i < listOfAllowedPermissions.length; i++) {
        const permission = listOfAllowedPermissions[i];
        if (userPermissions.indexOf(permission) > -1) {
            return true;
        }
    }

    return false;
};
